export default __webpack_public_path__ + "static/media/raffaele-attanasio.b623884f.jpg";